/** Join conditional class names. Three lines, no dependency.
 *
 *  NOTE: this does NOT de-duplicate conflicting utilities. Same-property
 *  utilities are resolved by stylesheet order, not by the order they appear
 *  here — so never pass both `border-l-transparent` and `border-l-bad` and
 *  expect the second to win. Choose between them with a ternary so only one
 *  class is ever emitted. */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
